import React from 'react';

import { useAuthContext } from '../../../login/view-model/contexts/auth-context/AuthContextV1';
import {
  countOfLiveOrder,
  isCourierOrder,
  orderCrn,
  allocationLinkRedirect,
  courierTrackingLinkRedirect,
} from '@porterin/booking-flow/src/order-history/view/helpers/OrderHistoryHelper';

import { oms_url } from '../../../../shared/config/AppConfig';
import {
  LIVE_ORDER_CARD_STATUS,
  LIVE_ORDER_CARD_TEXT,
  LIVE_ORDER_BUTTON,
} from '../../domian/store/OrderHistoryConstants';

import styles from '../styles/LiveOrderCard.module.scss';

function LiveOrderCardCmp(): React.ReactElement | null {
  const { order_history } = useAuthContext();

  const onTrackHandler = (): void => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const history = order_history as any;
    if (countOfLiveOrder(history) > 1) {
      window.location.href = oms_url + '/order-history';
    } else if (isCourierOrder(history, 0)) {
      courierTrackingLinkRedirect(orderCrn(history, 0));
    } else {
      allocationLinkRedirect(orderCrn(history, 0));
    }
  };

  if (order_history.state !== 'Live' || !order_history.data || order_history.data.length === 0) {
    return null;
  }

  return (
    <div className={styles['live-order-card-container']}>
      <div className={styles['live-order']}>
        <div className={styles['live']}>{LIVE_ORDER_CARD_STATUS}</div>
        <div className={styles['text']}>{LIVE_ORDER_CARD_TEXT}</div>
      </div>
      <button className={styles['view-status']} onClick={onTrackHandler}>
        {LIVE_ORDER_BUTTON}
      </button>
    </div>
  );
}

export default LiveOrderCardCmp;
